import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

 export interface logic{
  edata:any
}
@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    standalone: false
})
export class TextAreaComponent implements OnInit {
 buttonColor: string;
  logic: any;

  constructor(public dialogRef:MatDialogRef<TextAreaComponent>,private localstorage:LocalStorageSettingsService,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: logic) { }

  ngOnInit(): void {
    console.log(this.data.edata)
    this.logic = this.data.edata
    this.buttonColor = this.localstorage.getSettings("ColorA")

  }
   cancel(){
      this.dialogRef.close();
    }

    copyLogic() {
  if (!this.logic) {
    return;
  }
  navigator.clipboard.writeText(this.logic).then(
    () => {
      console.log('Copied to clipboard successfully!');
      this.snackbar.open('Copied to clickboard successfully!',"Ok",{duration:5000})
      // Optional: show a snackbar or alert
    },
    (err) => {
      console.error('Could not copy text: ', err);
    }
  );
}


}
